<container-padrao>
    <video width="100%" height="auto" controls>
        <source src="assets/videos/tutorial-video-sistema.mp4" type="video/mp4">
        Seu navegador não suporta o elemento de vídeo.
    </video>

    <div class="mt-5 d-grid justify-content-center">
        <primary-button
            icon="play_circle"
            text="Iniciar"
            (click)="iniciar()"
        ></primary-button>
    </div>
</container-padrao>